'use client';

import { ErrorBoundary } from '@toss/error-boundary';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Stack } from '@zep/ui';
import { useAppDetail } from '../../../../../services';
import S from './UploadForm/AppUpload.module.scss';
import { AppUploadForm } from './UploadForm/AppUploadForm';
import { _AppUploadGuide } from './components';
export const _UpdateApp = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['accounts']);
  const {
    data,
    isSuccess
  } = useAppDetail(
  // @ts-ignore
  router.query.id?.toString());
  const initValues = isSuccess ? {
    name: data?.name,
    type: +data?.type,
    icon: data?.finalIconUrl ?? 'none_image',
    url: data?.url ?? '',
    description: data?.description,
    file: 'alreadyFile'
  } : undefined;
  return <div className={S.wrapper} data-sentry-component="_UpdateApp" data-sentry-source-file="UpdateApp.tsx">
      <div className={S.title}>{t('accounts:myApp.update.appUpdate')}</div>
      <_AppUploadGuide data-sentry-element="_AppUploadGuide" data-sentry-source-file="UpdateApp.tsx" />
      <div className={S.container}>
        <AppUploadForm.Provider initValues={initValues} data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx">
          <AppUploadForm.InputName data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx" />
          <AppUploadForm.InputDescription data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx" />
          <AppUploadForm.SelectType data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx" />
          <AppUploadForm.UploadAppIcon data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx" />
          <AppUploadForm.InputLocalZepFilePath data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx" />
          <AppUploadForm.UploadFile data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx" />
          <Stack direction={'row'} gap={8} data-sentry-element="Stack" data-sentry-source-file="UpdateApp.tsx">
            <AppUploadForm.SubmitButton title={t('accounts:myApp.update.updateButton')} isUpdated appHashId={data?.hashId} data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx" />
            <AppUploadForm.DeleteButton
          // @ts-ignore
          appHashId={data?.hashId}
          // @ts-ignore
          appName={data?.name} data-sentry-element="unknown" data-sentry-source-file="UpdateApp.tsx" />
          </Stack>
        </AppUploadForm.Provider>
      </div>
    </div>;
};
export const UpdateApp = () => {
  const router = useRouter();
  return <ErrorBoundary renderFallback={() => null} onError={() => router.push('/404')} data-sentry-element="ErrorBoundary" data-sentry-component="UpdateApp" data-sentry-source-file="UpdateApp.tsx">
      <_UpdateApp data-sentry-element="_UpdateApp" data-sentry-source-file="UpdateApp.tsx" />
    </ErrorBoundary>;
};